import React from 'react';
import { CircularProgress } from '@material-ui/core';

import './index.css';

interface Props {
    label?: string,
    loading?: boolean
    width?: string,
    height?: string,
    padding?: string,
    heightIcon?: string,
    widthIcon?: string,
    heightLabel?: string,
    widthLabel?: string,
}

const LcLoading: React.FC<Props> = (props) => {
    return (
        <>
            {
                props.loading
                    ? <div
                        className={"lc-loading"}
                        style={{
                            width: (props.width) ? props.width : "100%",
                            height: (props.height) ? props.height : "auto",
                            padding: (props.padding) ? props.padding : "inherit"
                        }}>
                        <CircularProgress
                            style={{
                                height: (props.heightIcon) ? props.heightIcon : "40px",
                                width: (props.widthIcon) ? props.widthIcon : "40px"
                            }}
                        />
                        {
                            props.label &&
                            <span className={"label"} style={{ height: props.heightLabel, width: props.widthLabel }}> {props.label} </span>
                        }
                    </div>
                    : props.children
            }
        </>
    );
}

export default LcLoading;